import { cn } from '../../lib/cn';
import type { CertificationRow } from '../../enterprisequality/framework';

type Props = { certifications?: CertificationRow[] };

export function ReleaseCertificationPanel({ certifications = [] }: Props) {
  return (
    <div className="space-y-2">
      {certifications.map((c) => (
        <div key={c.type} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{c.type}</p>
            <p className="text-xs text-slate-500">issued {c.issued}</p>
          </div>
          <div className="text-right">
            <p className="text-lg font-semibold">{c.score}%</p>
            <span className={cn(
              'text-xs font-medium uppercase',
              c.status === 'certified' || c.status === 'go' ? 'text-success-600' : 'text-warning-600',
            )}>
              {c.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
